import React, { ReactNode, useCallback } from 'react';
import { NavigationHelperProvider } from '@cko/dashboard-shared';
import { useNavigation } from '../NavigationProvider';
import { useDrawerContext } from '../DrawerManager';
import { useDynamicHeaderContext } from '../DynamicHeaderProvider';

export const NavigationHelperContextProvider = (props: { children: ReactNode }) => {
  const { children } = props;
  const { getUrlForRoute, filteredMenuItems, getSearchDataByParentRouteId } = useNavigation();
  const { setPageDescription } = useDynamicHeaderContext();
  const { showDrawerInstance, closeDrawerInstance } = useDrawerContext();

  const getMenuItemsByGroupId = useCallback(
    (groupId: string) => {
      return filteredMenuItems[groupId] ?? undefined;
    },
    [filteredMenuItems],
  );

  return (
    <NavigationHelperProvider
      getUrlForRoute={getUrlForRoute}
      showDrawer={showDrawerInstance}
      closeDrawer={closeDrawerInstance}
      getMenuItemsByGroupId={getMenuItemsByGroupId}
      getSearchDataByParentRouteId={getSearchDataByParentRouteId}
      setPageDescription={setPageDescription}
    >
      {children}
    </NavigationHelperProvider>
  );
};
